import { TwoTilesBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpTwoTilesBlock } from './AmpTwoTilesBlock';
import { TwoTilesBlock } from './TwoTilesBlock';

export const TwoTilesBlockMapping: BlockMapping<TwoTilesBlockData> = {
  invariant: [
    {
      prop: 'tileOneHeadline',
      msg: 'Tile One Heading required for Two Tiles',
    },
    {
      prop: 'tileTwoHeadline',
      msg: 'Tile Two Heading required for Two Tiles',
    },
  ],
  width: 'GRID',
  Component: TwoTilesBlock,
  AmpComponent: AmpTwoTilesBlock,
};
